import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ModifyReservationsComponent } from '../components/modify-reservations/modify-reservations.component';
import { LegacyBookInitService } from '../legacy-bookexpress/services/legacy-book-initializer.service';
import { HttpService } from '../legacy-bookexpress/services/http.service';
import { catchError, tap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { IGuestDetails, IUpdateReservation } from '../interfaces/update-reservation';
import { ReservationService } from '../legacy-bookexpress/services/reservation.service';
import { HttpClient } from '@angular/common/http';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root',
})
export class ModifyReservationsService {
  updatedRoom: any = [];
  oldRoom: any = [];
  enableKeyInGuestDetais: boolean;
  doNotPrefillGuestDetails: boolean;
  inValidModifyRoomSelection = '';
  constructor(
    private dialog: MatDialog,
    private configService: LegacyBookInitService,
    private httpService: HttpService,
    private reservationService: ReservationService,
    public http: HttpClient
  ) {
    this.enableKeyInGuestDetais = this.configService.PropertyData.permissions.functionalPermissions.enableKeyInGuestDetails;
    this.doNotPrefillGuestDetails = this.configService.PropertyData.permissions.functionalPermissions.doNotPrefillGuestDetails;
  }

  openModifyReservationsDialog(currencyDetails = 'USD', data = {}) {
    this.dialog.open(ModifyReservationsComponent, {
      width: '98vw !important',
      maxWidth: '98vw !important',
      height: '98vh !important',
      maxHeight: '98vh !important',
      disableClose: true,
      data: { currencyDetails: currencyDetails, ...data },
    });
  }

  Left(str, n) {
    if (n <= 0) return '';
    else if (n > String(str).length) return str;
    else return String(str).substring(0, n);
  }

  Right(str, n) {
    if (n <= 0) return '';
    else if (n > String(str).length) return str;
    else {
      var iLen = String(str).length;
      return String(str).substring(iLen, iLen - n);
    }
  }

  mask(s) {
    if (!s) {
      return '';
    }
    let result = '';
    for (var i = 0; i < s.length; i++) {
      result = result + '*';
    }
    return result;
  }

  setCardIcon(cardDetailCode) {
    let cardIcon = '';
    switch (cardDetailCode) {
      case 'MC':
      case 'mastercard':
      case 'masterCard':
        cardIcon = 'mastercard';
        break;
      case 'VSA':
      case 'visa':
        cardIcon = 'visa';
        break;
      case 'AMX':
      case 'americanexpress':
      case 'amex':
      case 'americanExpress':
        cardIcon = 'americanexpress';
        break;
      case 'DC':
      case 'diners-club':
      case 'dinersclub':
      case 'dinersClub':
        cardIcon = 'dinersclub';
        break;
      case 'DIS':
      case 'discover':
        cardIcon = 'discover';
        break;
      case 'JCB':
      case 'jcb':
        cardIcon = 'jcb';
        break;
      default:
        cardIcon = 'creditcard';
    }

    return cardIcon;
  }

  updateResCall() {
    let confNo = this.reservationService.reservationData.confirmationId;
    let resId = this.reservationService.reservationData.reservationID;

    let putData: IUpdateReservation = {
      roomType: this.updatedRoom[0].room['roomType'],
      wing: this.updatedRoom[0].room['wing'],
      arrivalDate: moment(this.updatedRoom[0].arrival).format('YYYY-MM-DD'),
      departureDate: moment(this.updatedRoom[0].departure).format('YYYY-MM-DD'),
      adults: this.updatedRoom[0].adults,
      juniors: this.updatedRoom[0].juniors,
      children: this.updatedRoom[0].children,
      infants: this.updatedRoom[0].infants,
    };

    const updatedGuest = this.updatedRoom[0]?.guestDetails.map((obj) => {
      const { guestSerialno, ...objWithoutGuestSerialno } = obj;
      return objWithoutGuestSerialno;
    });
    const oldGuest = this.oldRoom[0]?.guestDetails;
    let oldPutData: IUpdateReservation = {
      roomType: this.oldRoom[0].room['roomType'],
      wing: this.oldRoom[0].room['wing'],
      arrivalDate: moment(this.oldRoom[0].arrival).format('YYYY-MM-DD'),
      departureDate: moment(this.oldRoom[0].departure).format('YYYY-MM-DD'),
      adults: this.oldRoom[0].adults,
      juniors: this.oldRoom[0].juniors,
      children: this.oldRoom[0].children,
      infants: this.oldRoom[0].infants,
    };
    if (this.updatedRoom[0]?.cardDetails?.isNewCard) {
      putData.cardToken = this.updatedRoom[0]?.cardDetails?.token;
      putData.cardCode = this.updatedRoom[0]?.cardDetails?.cardInfo?.cardIssuer;
      putData.cardMasked = this.updatedRoom[0]?.cardDetails?.cardInfo?.accountNumberMasked;
      putData.cardExpireDate = this.processExpiryDate(this.updatedRoom[0]?.cardDetails?.cardInfo?.expirationYearMonth);
    } else {
      if (!this.oldRoom[0]?.cardDetails?.cardLast4) {
        this.oldRoom[0].currency = this.updatedRoom[0]?.currency;
      }
      putData.currency = this.updatedRoom[0]?.currency;
      oldPutData.currency = this.updatedRoom[0]?.currency;
    }
    //checking is there any changes to save
    if (
      ((!this.oldRoom[0]?.cardDetails?.isNewCard && !this.updatedRoom[0]?.cardDetails?.isNewCard && !putData.currency) ||
        (!this.oldRoom[0]?.cardDetails?.isNewCard && putData?.currency)) &&
      JSON.stringify(oldGuest) === JSON.stringify(updatedGuest) &&
      JSON.stringify(oldPutData) === JSON.stringify(putData)
    ) {
      return of({
        Status: false,
        ErrorMessage: this.configService?.PropertyData?.rGuestMessages?.book?.noChangeDetectedErrorMsg || 'No changes detected',
      });
    }
    if (this.updatedRoom[0]?.guestDetails?.length > 1) {
      putData.guestDetails = this.formAdditionalGuestObject();
    }
    let updateResProp = this.configService.PropertyData.PropNameKeyList.updateres;
    let servername = this.configService.getServerUpdateRes();
    let tenantId = this.configService.gettenantId();

    let url =
      this.configService.getCloudDomainName() +
      '/' +
      servername +
      '/tenants/' +
      tenantId +
      ('/context/' + this.configService.PropertyData.ContextId + '/') +
      'propertyName/' +
      updateResProp +
      `/resID/${resId}?confNo=${confNo}&appName=wbe`;

    // Testing Purpose
    // url = `http://ag800:9087/RESTSERVICE/RESTWSRVG.PGM?propertyName=ALPHA-UPDATERES&CONFNO=${confNo}&RESID=${resId}`;

    // httpService
    // return this.http.put(url, putData, this.configService.serviceHeaders).pipe(
    //   tap((data) => console.log(data)),
    //   catchError(this.handleError('updateRes', []))
    // );

    return this.httpService.put(url, putData, this.configService.serviceHeaders).pipe(
      tap((data) => console.log(data)),
      catchError(this.handleError('updateRes', []))
    );
  }

  formAdditionalGuestObject() {
    let modifiedAdditonalGuest: IGuestDetails[] = [];
    this.updatedRoom[0].guestDetails?.forEach((eachGuests, index) => {
      if (
        eachGuests.id !== 0 &&
        (eachGuests.hasOwnProperty('addNameId') || (!eachGuests.hasOwnProperty('addNameId') && !eachGuests?.action))
      ) {
        const guestObj: any = {
          naType: 'A',
          lastName: eachGuests.lName,
          firstName: eachGuests.fName,
          title: eachGuests.title,
          cityName: eachGuests.city,
          stateProvinceCode: eachGuests.state,
          postalCode: eachGuests.postalCode,
          countryCode: eachGuests.country,
          casinoNumber: eachGuests.casinoNo,
          cellPhone: eachGuests.mobile,
          emailAddress: eachGuests.email,
          dialCode: eachGuests.dialCode,
          addNameId: eachGuests.addNameId,
        };
        if (eachGuests.action) {
          guestObj.action = eachGuests.action;
        }

        this.addAddressInfo(eachGuests, guestObj);
        modifiedAdditonalGuest.push(guestObj);
      }
    });
    return modifiedAdditonalGuest;
  }

  private addAddressInfo(guestInfo, updatedGuestInfo) {
    if (guestInfo.casinoNo && (this.enableKeyInGuestDetais || this.doNotPrefillGuestDetails)) {
      updatedGuestInfo.addressLine1 = guestInfo.address;
      updatedGuestInfo.addressLine2 = '';
    } else if (guestInfo.casinoNo) {
      updatedGuestInfo.addressLine1 = guestInfo.addressLine1;
      updatedGuestInfo.addressLine2 = guestInfo.addressLine2;
    } else {
      updatedGuestInfo.addressLine1 = guestInfo.address;
      updatedGuestInfo.addressLine2 = '';
    }
  }

  processExpiryDate(expirationYearMonth) {
    return this.Right(expirationYearMonth, 2) + this.Left(expirationYearMonth, 4).replace('20', '');
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      console.error(error);
      return of(result as T);
    };
  }
}
